import { IGaugeChartProps } from './types'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more.js'
import SolidGauge from 'highcharts/modules/solid-gauge.js'
import HighchartsReact from 'highcharts-react-official'
import { defaultOptions } from './defaultOptions'
import { getColorForValue } from './getColorForValue'
import styles from './styles.module.scss'
import useContainerSize from '@/hooks/useContainerSize'
import { CustomCSSProperties } from 'moralis-ui'
import { useRef } from 'react'
import merge from 'lodash/merge'

// @see https://www.npmjs.com/package/highcharts-react-official#highcharts-with-nextjs
if (typeof Highcharts === 'object') {
  HighchartsMore(Highcharts)
  SolidGauge(Highcharts)
}

const GaugeChart = ({
  stops = [],
  min = 0,
  max = 0,
  hasAnimation = true,
  value = 0,
  showLabels = false,
  showValue = true,
  valueColorChange = true,
  valuePrefix,
  valueSuffix,
  fontSize,
  backgroundColorHex,
  backgroundColorOpacity = 0.2,
}: IGaugeChartProps) => {
  const [ref, width, height] = useContainerSize()
  const chartRef = useRef(null)

  const currentBGColor = getColorForValue(value, stops, min, max, backgroundColorOpacity)
  const currentValueColor = getColorForValue(value, stops, min, max, 1)

  const labelFormat = `<div class=${styles.valueHolder}><span class=${styles.value} style="${fontSize ? `font-size: ${fontSize}px ` : ''} ${
    valueColorChange && `color: ${currentValueColor}`
  }">${valuePrefix ? valuePrefix : ''}{y}${valueSuffix ? valueSuffix : ''}</span></div>`

  const customOptions = {
    yAxis: {
      stops: stops,
      min: min,
      max: max,
      labels: {
        enabled: showLabels,
      },
    },
    series: [
      {
        data: [value],
        dataLabels: {
          format: labelFormat,
        },
      },
    ],
    plotOptions: {
      solidgauge: {
        animation: hasAnimation,
        dataLabels: {
          enabled: showValue,
        },
      },
    },
    pane: {
      background: {
        backgroundColor: backgroundColorHex ? backgroundColorHex : currentBGColor,
      },
    },
  }

  const chartOptions = merge({}, defaultOptions, customOptions)

  return (
    <div
      ref={ref}
      className={styles.chartHolder}
      style={
        {
          '--container-width': `${width}px`,
          '--container-height': `${height}px`,
        } as CustomCSSProperties
      }
    >
      <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} />
    </div>
  )
}

export default GaugeChart
